// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .navbar {
    background-color: #1f5156;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem;
    position: sticky;
    top: 0;
    z-index: 20;
  }
  
  .nav-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 80px;
    max-width: auto;
    position: relative;
  }
  
  .nav-logo {
    color: #f5b921;
    align-items: center;
    margin-left: 20px;
    cursor: pointer;
    text-decoration: none;
    font-size: 2rem;
    flex-grow: 1;
  
    display: flex;
    align-items: left;
    justify-items: left;
  }
  
  .nav-logo .icon {
    display: inline-block;
    width: 3rem;
    height: 3rem;
    margin-left: 16px;
  }
  
  .nav-menu {
    display: flex;
    list-style: none;
    text-align: center;
    margin-right: 2rem;
  }
  
  .nav-links {
    color: #fff;
    text-decoration: none;
    padding: 0.5rem 1rem;
    height: 100%;
    border-bottom: 3px solid transparent;
  }
  
  .nav-item {
    line-height: 40px;
    margin-right: 1rem;
  }
  
  .nav-item:after {
    content: "";
    display: block;
    height: 3px;
    width: 0;
    background: transparent;
    transition: width 0.7s ease, background-color 0.5s ease;
  }
  
  .nav-item:hover:after {
    width: 100%;
    background: #ffdd40;
  }
  
  .nav-item .active {
    color: #ffdd40;
    border: 1px solid #ffdd40;
  }
  
  .nav-icon {
    display: none;
    color: #f5b921;
  }
  
  .nav-icon .icon {
    display: inline-block;
    width: 2rem;
    height: 2rem;
  }
  
  @media screen and (max-width: 960px) {
    .nav-menu {
      display: flex;
      flex-direction: column;
      width: 100%;
      border-top: 1pxsolid #fff;
      position: absolute;
      top: 80px;
      left: -110%;
      opacity: 1;
      transition: all 0.5s ease;
    }
  
    .nav-menu.active {
      background: #1f5156;
      left: 0px;
      opacity: 1;
      transition: all 0.5s ease;
      z-index: 1;
    }
    .nav-item .active {
      color: #ffdd40;
      border: none;
    }
    .nav-links {
      padding: 1.5rem;
      width: 100%;
      display: table;
    }
  
    .nav-logo .icon {
      width: 2rem;
      height: 2rem;
    }
  
    .nav-icon {
      display: block;
      position: absolute;
      top: 50%;
      right: 0;
      transform: translate(-100%, -50%);
      width: 2rem;
      height: 2rem;
      cursor: pointer;
      color: #ffdd40;
    }
  } */

  .navbar.sidebar {
    background-color: #1f5156;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    font-size: 1.2rem;
    position: fixed;
    top: 0;
    left: 0;
    right: 20%;
    z-index: 20;
    width: 250px;
    transition: width 0.5s ease;
  }
  
  .navbar.sidebar-hidden {
    width: 0;
    /* left: -250px; */
    transition: width 0.5s ease, left 0.5s ease;
    overflow: hidden;
  }
  
  .nav-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    padding-top: 20px;
  }
  
  .nav-logo {
    color: #f5b921;
    margin-left: 20px;
    cursor: pointer;
    text-decoration: none;
    font-size: 2rem;
    display: flex;
    align-items: center;
    margin-bottom: 2rem;
  }
  
  .nav-logo .icon {
    display: inline-block;
    width: 3rem;
    height: 3rem;
    margin-left: 16px;
  }
  
  .nav-menu {
    display: flex;
    flex-direction: column;
    list-style: none;
    width: 100%;
    padding-left: 0;
  }
  
  .nav-menu.active {
    display: flex;
  }
  
  .nav-links {
    color: #fff;
    text-decoration: none;
    padding-top: 1rem;
    padding-bottom: 1rem;
    padding-left: 0.1rem;
    text-align: center;
    width: 100%;
    display: block;
    border-bottom: 1px solid transparent;
  }
  
  .nav-item {
    width: 100%;
  }
  
  .nav-item:hover .nav-links {
    background-color: #ffdd40;
    color: #1f5156;
  }
  
  .nav-item .active {
    color: #ffdd40;
    border: none;
  }
  
  .nav-icon {
    display: none;
    color: #f5b921;
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
  }
  
  .nav-icon .icon {
    display: inline-block;
    width: 2rem;
    height: 2rem;
  }
  
  .toggle-button {
    position: absolute;
    top: 20px;
    /* right: -30px; */
    right: -10%;
    background-color: #1f5156;
    color: #f5b921;
    padding: 10px;
    cursor: pointer;
    font-size: 1.2rem;
    border-radius: 5px;
  }

  .toggle-button-hidden{
    /* right: -10%; */
    position: absolute;
    top: 20px;
    background-color: #1f5156;
    color: #f5b921;
    padding: 10px;
    cursor: pointer;
    font-size: 1.2rem;
    border-radius: 5px;
  }
  
  @media screen and (max-width: 960px) {
    .nav-icon {
      display: block;
    }
  
    .nav-menu {
      position: absolute;
      top: 0;
      left: -250px;
      width: 250px;
      height: 100%;
      background-color: #1f5156;
      transition: left 0.5s ease;
      z-index: 1;
    }
  
    .nav-menu.active {
      left: 0;
    }
  
    .nav-links {
      padding: 1.5rem;
    }
  
    .nav-logo .icon {
      width: 2rem;
      height: 2rem;
    }
  
    .toggle-button {
      top: 20px;
      right: -40px; /* Adjust to position the toggle button correctly */
    }
  }

  .nav-logo-container {
    margin-top: 100%; 
    /* padding: 20px; */
    text-align: center;
    /* height: 100%; */
    display: flex;
    flex-direction: column;
    gap: 11%;
    padding: 10%;
    height: 72%;
  }
  
  .nav-logo-img {
    width: 100%; /* Adjust size as needed */
    height: auto;
    /* max-width: 200px; */
    /* max-height: 200px; */
  }
  
  .nav-logo-img-2{
    width: 100%; /* Adjust size as needed */
    height: auto;
  }`, "",{"version":3,"sources":["webpack://./src/components/NavBar.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KA2IK;;EAEH;IACE,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,MAAM;IACN,OAAO;IACP,UAAU;IACV,WAAW;IACX,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;IACE,QAAQ;IACR,kBAAkB;IAClB,2CAA2C;IAC3C,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,oCAAoC;EACtC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE;MACE,cAAc;IAChB;;IAEA;MACE,kBAAkB;MAClB,MAAM;MACN,YAAY;MACZ,YAAY;MACZ,YAAY;MACZ,yBAAyB;MACzB,0BAA0B;MAC1B,UAAU;IACZ;;IAEA;MACE,OAAO;IACT;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,SAAS;MACT,YAAY,EAAE,mDAAmD;IACnE;EACF;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW,EAAE,0BAA0B;IACvC,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW,EAAE,0BAA0B;IACvC,YAAY;EACd","sourcesContent":["/* .navbar {\r\n    background-color: #1f5156;\r\n    height: 80px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-size: 1.2rem;\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 20;\r\n  }\r\n  \r\n  .nav-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 80px;\r\n    max-width: auto;\r\n    position: relative;\r\n  }\r\n  \r\n  .nav-logo {\r\n    color: #f5b921;\r\n    align-items: center;\r\n    margin-left: 20px;\r\n    cursor: pointer;\r\n    text-decoration: none;\r\n    font-size: 2rem;\r\n    flex-grow: 1;\r\n  \r\n    display: flex;\r\n    align-items: left;\r\n    justify-items: left;\r\n  }\r\n  \r\n  .nav-logo .icon {\r\n    display: inline-block;\r\n    width: 3rem;\r\n    height: 3rem;\r\n    margin-left: 16px;\r\n  }\r\n  \r\n  .nav-menu {\r\n    display: flex;\r\n    list-style: none;\r\n    text-align: center;\r\n    margin-right: 2rem;\r\n  }\r\n  \r\n  .nav-links {\r\n    color: #fff;\r\n    text-decoration: none;\r\n    padding: 0.5rem 1rem;\r\n    height: 100%;\r\n    border-bottom: 3px solid transparent;\r\n  }\r\n  \r\n  .nav-item {\r\n    line-height: 40px;\r\n    margin-right: 1rem;\r\n  }\r\n  \r\n  .nav-item:after {\r\n    content: \"\";\r\n    display: block;\r\n    height: 3px;\r\n    width: 0;\r\n    background: transparent;\r\n    transition: width 0.7s ease, background-color 0.5s ease;\r\n  }\r\n  \r\n  .nav-item:hover:after {\r\n    width: 100%;\r\n    background: #ffdd40;\r\n  }\r\n  \r\n  .nav-item .active {\r\n    color: #ffdd40;\r\n    border: 1px solid #ffdd40;\r\n  }\r\n  \r\n  .nav-icon {\r\n    display: none;\r\n    color: #f5b921;\r\n  }\r\n  \r\n  .nav-icon .icon {\r\n    display: inline-block;\r\n    width: 2rem;\r\n    height: 2rem;\r\n  }\r\n  \r\n  @media screen and (max-width: 960px) {\r\n    .nav-menu {\r\n      display: flex;\r\n      flex-direction: column;\r\n      width: 100%;\r\n      border-top: 1pxsolid #fff;\r\n      position: absolute;\r\n      top: 80px;\r\n      left: -110%;\r\n      opacity: 1;\r\n      transition: all 0.5s ease;\r\n    }\r\n  \r\n    .nav-menu.active {\r\n      background: #1f5156;\r\n      left: 0px;\r\n      opacity: 1;\r\n      transition: all 0.5s ease;\r\n      z-index: 1;\r\n    }\r\n    .nav-item .active {\r\n      color: #ffdd40;\r\n      border: none;\r\n    }\r\n    .nav-links {\r\n      padding: 1.5rem;\r\n      width: 100%;\r\n      display: table;\r\n    }\r\n  \r\n    .nav-logo .icon {\r\n      width: 2rem;\r\n      height: 2rem;\r\n    }\r\n  \r\n    .nav-icon {\r\n      display: block;\r\n      position: absolute;\r\n      top: 50%;\r\n      right: 0;\r\n      transform: translate(-100%, -50%);\r\n      width: 2rem;\r\n      height: 2rem;\r\n      cursor: pointer;\r\n      color: #ffdd40;\r\n    }\r\n  } */\r\n\r\n  .navbar.sidebar {\r\n    background-color: #1f5156;\r\n    height: 100vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    font-size: 1.2rem;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 20%;\r\n    z-index: 20;\r\n    width: 250px;\r\n    transition: width 0.5s ease;\r\n  }\r\n  \r\n  .navbar.sidebar-hidden {\r\n    width: 0;\r\n    /* left: -250px; */\r\n    transition: width 0.5s ease, left 0.5s ease;\r\n    overflow: hidden;\r\n  }\r\n  \r\n  .nav-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    width: 100%;\r\n    height: 100%;\r\n    padding-top: 20px;\r\n  }\r\n  \r\n  .nav-logo {\r\n    color: #f5b921;\r\n    margin-left: 20px;\r\n    cursor: pointer;\r\n    text-decoration: none;\r\n    font-size: 2rem;\r\n    display: flex;\r\n    align-items: center;\r\n    margin-bottom: 2rem;\r\n  }\r\n  \r\n  .nav-logo .icon {\r\n    display: inline-block;\r\n    width: 3rem;\r\n    height: 3rem;\r\n    margin-left: 16px;\r\n  }\r\n  \r\n  .nav-menu {\r\n    display: flex;\r\n    flex-direction: column;\r\n    list-style: none;\r\n    width: 100%;\r\n    padding-left: 0;\r\n  }\r\n  \r\n  .nav-menu.active {\r\n    display: flex;\r\n  }\r\n  \r\n  .nav-links {\r\n    color: #fff;\r\n    text-decoration: none;\r\n    padding-top: 1rem;\r\n    padding-bottom: 1rem;\r\n    padding-left: 0.1rem;\r\n    text-align: center;\r\n    width: 100%;\r\n    display: block;\r\n    border-bottom: 1px solid transparent;\r\n  }\r\n  \r\n  .nav-item {\r\n    width: 100%;\r\n  }\r\n  \r\n  .nav-item:hover .nav-links {\r\n    background-color: #ffdd40;\r\n    color: #1f5156;\r\n  }\r\n  \r\n  .nav-item .active {\r\n    color: #ffdd40;\r\n    border: none;\r\n  }\r\n  \r\n  .nav-icon {\r\n    display: none;\r\n    color: #f5b921;\r\n    position: absolute;\r\n    top: 20px;\r\n    right: 20px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .nav-icon .icon {\r\n    display: inline-block;\r\n    width: 2rem;\r\n    height: 2rem;\r\n  }\r\n  \r\n  .toggle-button {\r\n    position: absolute;\r\n    top: 20px;\r\n    /* right: -30px; */\r\n    right: -10%;\r\n    background-color: #1f5156;\r\n    color: #f5b921;\r\n    padding: 10px;\r\n    cursor: pointer;\r\n    font-size: 1.2rem;\r\n    border-radius: 5px;\r\n  }\r\n\r\n  .toggle-button-hidden{\r\n    /* right: -10%; */\r\n    position: absolute;\r\n    top: 20px;\r\n    background-color: #1f5156;\r\n    color: #f5b921;\r\n    padding: 10px;\r\n    cursor: pointer;\r\n    font-size: 1.2rem;\r\n    border-radius: 5px;\r\n  }\r\n  \r\n  @media screen and (max-width: 960px) {\r\n    .nav-icon {\r\n      display: block;\r\n    }\r\n  \r\n    .nav-menu {\r\n      position: absolute;\r\n      top: 0;\r\n      left: -250px;\r\n      width: 250px;\r\n      height: 100%;\r\n      background-color: #1f5156;\r\n      transition: left 0.5s ease;\r\n      z-index: 1;\r\n    }\r\n  \r\n    .nav-menu.active {\r\n      left: 0;\r\n    }\r\n  \r\n    .nav-links {\r\n      padding: 1.5rem;\r\n    }\r\n  \r\n    .nav-logo .icon {\r\n      width: 2rem;\r\n      height: 2rem;\r\n    }\r\n  \r\n    .toggle-button {\r\n      top: 20px;\r\n      right: -40px; /* Adjust to position the toggle button correctly */\r\n    }\r\n  }\r\n\r\n  .nav-logo-container {\r\n    margin-top: 100%; \r\n    /* padding: 20px; */\r\n    text-align: center;\r\n    /* height: 100%; */\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 11%;\r\n    padding: 10%;\r\n    height: 72%;\r\n  }\r\n  \r\n  .nav-logo-img {\r\n    width: 100%; /* Adjust size as needed */\r\n    height: auto;\r\n    /* max-width: 200px; */\r\n    /* max-height: 200px; */\r\n  }\r\n  \r\n  .nav-logo-img-2{\r\n    width: 100%; /* Adjust size as needed */\r\n    height: auto;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
